import Vue from "vue";
import VueRouter from "vue-router";
const About = () => import("../views/About.vue");
const Blogs = () => import("../views/Blogs.vue");
const Publications = () => import("../views/Publications.vue");
const Books = () => import("../views/Books.vue");
const Home = () => import("../views/Home.vue");
const Poems = () => import("../views/Poems.vue");
const helpScrn = () => import("../views/helpScrn.vue");
const Mblogs = () => import("../views/Mblogs.vue");
const Mpublications = () => import("../views/Mpublications.vue");
const Mpoems = () => import("../views/Mpoems.vue");
const Mbooks = () => import("../views/Mbooks.vue");
const NotFound = () => import("../views/NotFound.vue");

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/About",
    name: "About",
    component: About
  },
  {
    path: "/Blogs",
    name: "Blogs",
    component: Blogs,
  },
  {
    path: "/Publications",
    name: "Publications",
    component: Publications,
  },
  {
    path: "/Books",
    name: "Books",
    component: Books,
  },
  {
    path: "/Poems",
    name: "Poems",
    component: Poems,
  },
  {
    path: "/helpScrn",
    name: "Help",
    component: helpScrn,
  },
  {
    path: "/Mblogs",
    name: "MBlogs",
    component: Mblogs,
  },
  {
    path: "/Mpublications",
    name: "Mpublications",
    component: Mpublications,
  },
  {
    path: "/Mbooks",
    name: "Mbooks",
    component: Mbooks,
  },
  {
    path: "/Mpoems",
    name: "Mpoems",
    component: Mpoems,
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

export default router;
